import { RblServerItem } from '@nirvana/shared/dtos/types/policies/common';
import { WEB_COMPONENT_EXCHANGE_ANTISPAM_SETTINGS_TABLE } from 'apps/webcomponents/src/webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { customElement } from 'lit/decorators.js';
import { getTableColumns } from './grid-config';
import { html } from 'lit';
import { TemplateResult } from 'lit/development';
import { GRID_ITEM_FORM_ID } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { toggleVisibility } from '../../../../../../../../utils/htmlElement.utils';

@customElement(WEB_COMPONENT_EXCHANGE_ANTISPAM_SETTINGS_TABLE)
export class GzExchangeAntispamSettingsTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  RblServerItem,
  RblServerItem
> {
  protected columns = getTableColumns.bind(this)();
  protected hasReorderRowAction = false;
  protected renderGridItemForm(): TemplateResult {
    return html`<gz-policy-panel-exchange-antispam-settings-item
      id="${GRID_ITEM_FORM_ID}"
    ></gz-policy-panel-exchange-antispam-settings-item>`;
  }

  protected async onGridItemsChange() {
    await this.gridComponent.updateComplete;
    this.toggleGridVisibility(
      !(this.gridComponent.getFormValue() === undefined || this.gridComponent?.getFormValue().length === 0)
    );
  }
  public toggleGridVisibility(hasItems: boolean) {
    toggleVisibility(this.gridComponent, hasItems);
  }
}
